var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "profile-field__title" }, [
      _vm._v("Персональная информация"),
    ]),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _vm.field.personalData.familyStatus.show
          ? _c(
              "div",
              { staticClass: "form-group family-status" },
              [
                _c("c-select", {
                  attrs: {
                    type: "select",
                    "floating-label": "Семейное положение",
                    items: _vm.options,
                    clearable: true,
                    "custom-options":
                      _vm.field.personalData.familyStatus.custom,
                    "required-mark":
                      _vm.field.personalData.familyStatus.required,
                    invalid: !!(_vm.error && _vm.error.familyStatus),
                    error: _vm.error && _vm.error.familyStatus,
                  },
                  model: {
                    value: _vm.familyStatus,
                    callback: function ($$v) {
                      _vm.familyStatus = $$v
                    },
                    expression: "familyStatus",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.field.personalData.hasChildren
          ? _c(
              "div",
              [
                _c("c-switcher", {
                  attrs: { label: "Есть дети" },
                  model: {
                    value: _vm.hasChildren,
                    callback: function ($$v) {
                      _vm.hasChildren = $$v
                    },
                    expression: "hasChildren",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.hasChildren
            ? _c("div", { staticClass: "children" }, [
                _c(
                  "div",
                  { staticClass: "children__list" },
                  _vm._l(_vm.children, function (child, i) {
                    return _c("child", {
                      key: child.unique,
                      attrs: {
                        child: child,
                        error: _vm.error && _vm.error.children[i],
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.removeChild(child)
                        },
                      },
                    })
                  }),
                  1
                ),
                _c(
                  "div",
                  { staticClass: "children__add" },
                  [
                    _c("c-button", {
                      attrs: {
                        icon: { icon: "plus", color: "primary" },
                        label: "Добавить ребенка",
                        disabled: _vm.preview || _vm.hasEmptyChildren,
                        size: "small",
                      },
                      on: { click: _vm.addChild },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }